import api from "../../services/api";

/* Funcão de criar customer */

export const createCustomer = async (customerToSend: any, token: string) => {
  return await api.post(`/api/customer`, customerToSend, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const removeOptInWhatsApp = async (phone:string,token: string) => {
  return await api.post(
    `/api/zapnis-web/`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },

    }
  );
}